import(/* webpackMode: "eager" */ "/var/www/front/live/eduvalu-front/app/subjects/page.tsx")